/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import { history } from '../../core/history';
// import { DropzoneArea } from '../../components/Form/DropzoneAreaExt'
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import I18n from '../../components/Translate/I18n';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';

import { ImportExport, SaveAlt } from '@material-ui/icons';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import InputFormRest from '../../components/Form/InputFormRest';
import CustomButtom from '../../components/CustomButtons/ButtonExt';
import CancelTextButton from '../../components/Buttons/CancelTextButtons';
import SelectSingleReseller from '../../components/Form/SelectSingleReseller';
import { iccidActions, iccidConstants } from '../../modules/iccid/actions';
import DropzoneAreaExt from '../../components/Form/DropzoneAreaExt';
import { IccidRange, IccidRangeStatus } from '../../modules/iccid/EntityRange';
import { store } from '../../core/store';
import { iccidReducers } from '../../modules/iccid/reducers';
import { componentDebug } from 'core/debug';

class IccidEdit extends Component {
    constructor(props) {
        super(props);

        store.injectReducer('iccidReducers', iccidReducers);

        const id = '/' + this.props.match.params.id;

        this.state = {
            entity: IccidRange,
            entityStatus: IccidRangeStatus,
            success: false,
            id: null,
            platformIccidPoolUri: id,
            action: null,
        };
        this.props.handleSetBrandText('');
        this.initial(id);
    }

    initial = (id) => {
        const { dispatch } = this.props;
        if (this.state.platformUri === null) {
            /**
             * @todo redirect to item not found page
             */
        }
        const obj = this.props.handleGetObjectByKey('platformIccidPoolList', id);
        if (obj) {
            dispatch({ ...this.state, type: iccidConstants.LIST_ICCID_POOL_ITEM, item: obj });
        } else {
            dispatch(iccidActions.get(FormGeneralHelper.getByUri(id), iccidConstants.LIST_ICCID_POOL_ITEM));
        }
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const { dispatch } = this.props;
        if (nextProps.type === iccidConstants.LIST_ICCID_POOL_ITEM) {
            componentDebug(nextProps);
            componentDebug(nextState);
            this.setState((prevState) => ({
                entity: {
                    ...prevState.entity,
                    mainname: nextProps.item.mainname,
                    ownerResellerId: nextProps.item.ownerResellerId,
                },
            }));
            dispatch({ ...this.state, type: iccidConstants.LIST_ICCID_POOL_NO_ACTION });
            return false;
        }
        if (nextProps.type === iccidConstants.LIST_ICCID_POOL_EDIT_SAVE) {
            this.returnToList();
            return false;
        }
        return true;
    }

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue);
    };

    handleSubmit = (e) => {
        const { dispatch } = this.props;
        FormGeneralHelper.handleSubmit(this, e, this.submitCallBackDispatch, false, dispatch);
    };

    submitCallBackDispatch = () => {
        // const { dispatch } = this.props;
        //
        //dispatch(
        //    iccidActions.post(
        //        FormGeneralHelper.getUrl('/platform_iccid_pools'),
        //        this.state.entity,
        //        iccidConstants.LIST_ICCID_POOL_ADD_NEW
        //    )
        //);
    };

    uploadCallback = (file) => {
        const form = FormData();
        form.append('file', file.name);
        form.append('uri', this.state.platformIccidPoolUri);
    };

    selectResellerChange = (value) => {
        componentDebug(value);
        this.setState((prevState) => ({
            entity: {
                ...prevState.entity,
                ownerResellerId: value,
            },
        }));
    };

    returnToList = () => {
        history.push(FormGeneralHelper.getRouteUrl('/iccid-storage'));
    };

    render() {
        const { classes } = this.props;
        const { entity, entityStatus } = this.state;
        return (
            <form onSubmit={this.handleSubmit} key="pools_form">
                <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="info">
                                    <ImportExport />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    <I18n trans="pools:pool.edit_pool_iccid" />
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12}>
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="mainname"
                                            stateObjectState={entityStatus.mainname}
                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="pools:add.mainname"
                                            vMax={50}
                                            vMin={1}
                                            required={true}
                                            value={entity.mainname}
                                            labelText="pools:add.pool_name"
                                        />
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <SelectSingleReseller onChange={this.selectResellerChange} defaultValue={this.state.entity.ownerResellerId} />
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <CustomButtom type="submit">
                                            <I18n trans="general:common.save" />
                                        </CustomButtom>
                                        <CancelTextButton callback={this.returnToList} />
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} md={6}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="info">
                                    <SaveAlt />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    <I18n trans="pools:pool.upload_iccid_pools" />
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <DropzoneAreaExt uploadCallback={this.uploadCallback} />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </form>
        );
    }
}

IccidEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    const { iccidReducers } = state;
    if (iccidReducers === undefined) {
        return { ...state };
    }
    let success = false;
    if (iccidReducers.type === iccidConstants.LIST_ICCID_POOL_ADD_NEW) {
        success = iccidReducers.success;
    }
    return {
        success: success,
        type: iccidReducers.type,
        item: iccidReducers.item,
    };
};

const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));

const Enhance = enhance(IccidEdit);

export default Enhance;
